import { selectSubassignmentManagementState } from 'modules/subassignmentManagement/store/selectors';
import { IStore } from 'store/configureStore';

export const selectIsCompensationChangeOpened = (state: IStore) =>
    selectSubassignmentManagementState(state).compensationChange.isOpenBulkCreationModal;
